import { render, staticRenderFns } from "./SubscoreBreakdown.vue?vue&type=template&id=1166802c&scoped=true&"
import script from "./SubscoreBreakdown.vue?vue&type=script&lang=js&"
export * from "./SubscoreBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./SubscoreBreakdown.vue?vue&type=style&index=0&id=1166802c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166802c",
  null
  
)

export default component.exports